import { isEmpty } from 'lodash/fp'
import {
  ISortOrderEnum,
  IShipperRatesSortByEnum,
  Maybe,
  IFacilityScheduleRulesUnloadTypes,
} from 'types/graphqlTypes'
import { ShipperRatesFilters } from 'apps/marketplace/apiTypes/shipperRates'
import { SortOrder } from '../../shippers/utils/types/shipper'
import { IAwardedLanesQueryVariables } from '../graphql/AwardedLanes'
import { getLocationFilter } from './getLocationFilter'

interface IGetAwardedLanesQueryVariablesInput {
  currentUserId: Maybe<number>
  filters: ShipperRatesFilters
  sortField: IShipperRatesSortByEnum
  sortOrder: SortOrder
}

export const getAwardedLanesQueryVariables = ({
  currentUserId,
  filters,
  sortField,
  sortOrder,
}: IGetAwardedLanesQueryVariablesInput): IAwardedLanesQueryVariables => {
  const {
    assignedToMe,
    carrierApplicationId,
    carrierSalesRepId,
    deliveryCity,
    deliveryRadius,
    deliveryRegion,
    deliverySearchType,
    deliveryStateCode,
    dropType,
    equipmentId,
    pickupCity,
    pickupRadius,
    pickupRegion,
    pickupSearchType,
    pickupStateCode,
    shipperApplicationId,
    shipperRateId,
    sourceStatus,
  } = filters

  const pickupLocation = getLocationFilter({
    city: pickupCity,
    stateCode: pickupStateCode,
    radius: pickupRadius,
    regions: pickupRegion,
    searchType: pickupSearchType,
  })
  const deliveryLocation = getLocationFilter({
    city: deliveryCity,
    stateCode: deliveryStateCode,
    radius: deliveryRadius,
    regions: deliveryRegion,
    searchType: deliverySearchType,
  })

  const dropTypes = dropType?.map(type =>
    type === 'drop'
      ? IFacilityScheduleRulesUnloadTypes.DROP
      : IFacilityScheduleRulesUnloadTypes.LIVE
  )

  return {
    ...(isEmpty(pickupLocation) ? {} : { pickupLocation }),
    ...(isEmpty(deliveryLocation) ? {} : { deliveryLocation }),
    shipperRateId: shipperRateId ? `${shipperRateId}` : null,
    carrierSalesRepIds: [
      ...(assignedToMe ? [`${currentUserId}`] : []),
      ...(carrierSalesRepId ? [`${carrierSalesRepId}`] : []),
    ],
    sourceStatuses: sourceStatus || [],
    shipperApplicationIds: [...(shipperApplicationId ? [`${shipperApplicationId}`] : [])],
    carrierApplicationIds: [...(carrierApplicationId ? [`${carrierApplicationId}`] : [])],
    dropTypes: dropTypes || [],
    equipmentIds: equipmentId || [],
    sortBy: sortField,
    sortDirection: sortOrder === SortOrder.asc ? ISortOrderEnum.ASC : ISortOrderEnum.DESC,
    shouldSource: true,
  }
}
